__turbopack_context__.v({
  "collapsed": "spec-group-module-scss-module__7QEfEG__collapsed",
  "list": "spec-group-module-scss-module__7QEfEG__list",
  "specGroup": "spec-group-module-scss-module__7QEfEG__specGroup",
  "title": "spec-group-module-scss-module__7QEfEG__title",
});
